import React, { useEffect, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getEmpStart } from "store/SuperAdmin/Authentication/Users/action"
import TableContainer from "components/Common/TableContainer"
import Loader from "common/Loader"
import moment from "moment"
import { CardBody, Col, Row, Badge, Card } from "reactstrap"
import { useParams } from "react-router-dom"
import BackButton from "components/Common/BackButton"

const Home = () => {
  const { id} = useParams();
  const { loading, ViewEmployees } = useSelector(state => state.SuperUser)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getEmpStart(id))
  }, [])

  const columns = useMemo(
    () => [
      {
        Header: "Sr No",
        accessor: "id",
        Cell: cellProps => {
          return <>{cellProps.value}</>
        },
      },
      {
        Header: "Name",
        Cell: cellProps => {
          return <>{cellProps.row.original.first_name + ' ' + cellProps.row.original.last_name}</>
        },
      },
      {
        Header: "Phone No.",
        accessor: "phone_no",
        Cell: cellProps => {
          return <>{cellProps.value}</>
        },
      },  
      {
        Header: "Email",
        accessor: "email",
        Cell: cellProps => {
          return <>{cellProps.value}</>
        },
      },   
      {
        Header: "Gender",
        accessor: "gender",
        Cell: cellProps => {
          return <>{cellProps.value}</>
        },
      },
      {
        Header: "Joining Date",
        accessor: "joining_date",
        Cell: cellProps => {
          return <>{cellProps.value}</>
        },
      },
      {
        Header: "Job Title",
        accessor: "job_title",
        Cell: cellProps => {
          return <>{cellProps.value}</>
        },
      },
      {
        Header: "Verification Status",
        accessor: "verificationStatus",
        Cell: cellProps => {
          return <>{cellProps.value}</>
        },
      },
    ],
    []
  )
  return (
    <div>
      <div className="page-content">
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              {loading ? (
                <Loader />
              ) : (
                <div>
                  <Card>
                  <CardBody>
                    <div className="d-flex align-items-center">
                      <h5 className="mb-0 card-title flex-grow-1">Employee Details</h5>
                      <BackButton/>

                    </div>
                  </CardBody>

                  <CardBody>
                    <TableContainer
                      columns={columns}
                      data={[ViewEmployees?.data || []]}
                      isGlobalFilter={true}
                      isAddOptions={false}
                      // handleJobClicks={handleJobClicks}
                      isJobListGlobalFilter={false}
                      isPagination={true}
                      iscustomPageSizeOptions={true}
                      isShowingPageLength={true}
                      customPageSize={10}
                      tableClass="table-bordered align-middle nowrap mt-2"
                      paginationDiv="col-sm-12 col-md-7"
                      pagination="pagination justify-content-end pagination-rounded"
                    />
                  </CardBody>
                  </Card>
             
                </div>
              )}
            </Col>
          </Row>
        </div>
      </div>
    </div>
  )
}

export default Home
